export default __webpack_public_path__ + "static/media/LIBRARY.d8b2178c.jpg";